module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1s-327px-b6164633522e56e4efd8ddef4c534d7a.gif";